import React from "react";
import InfoIcon from "../../../Assets/images/icon-info-circle.svg";

const TH = ({ children, style = {}, className }: any) => {
    return (
        <th className={`exposure-table-heading ${className ? className : ""}`} style={style} scope="col" role="columnheader">
            {children}
        </th>
    );
};

function ExposureTableHead(props: any) {
    const getTableName = (name: string) => {
        if (props.tableName === "detectedBreach" && props.titleNameDetectedBreach && props.titleNameDetectedBreach === name) {
            return true;
        }
        if (props.tableName === "savedBreach" && props.titleNameSavedBreach && props.titleNameSavedBreach === name) {
            return true;
        }

        return false;
    };

    const getRenderArrow = (name: string) => {
        if (props.tableName === "detectedBreach" && getTableName(name)) {
            return props.sortState.detectedBreach[name] ? (
                <span>
                    <em className="las la-arrow-up" style={{ color: "#00313c" }}></em>
                </span>
            ) : (
                <span>
                    <em className="las la-arrow-down" style={{ color: "#00313c" }}></em>
                </span>
            );
        }
        if (props.tableName === "savedBreach" && getTableName(name)) {
            return props.sortState.savedBreach[name] ? (
                <span>
                    <em className="las la-arrow-up" style={{ color: "#00313c" }}></em>
                </span>
            ) : (
                <span>
                    <em className="las la-arrow-down" style={{ color: "#00313c" }}></em>
                </span>
            );
        }

        return <></>;
    };

    return (
        <thead style={{ backgroundColor: "#f4f4f4" }}>
            <tr>
                <TH className={`${getTableName("organization") ? "highlight-exposure-table-heading" : ""}`}>
                    <button
                        className="header-button org-exposure-table"
                        onClick={() => {
                            props.handleSort("organization", props.tableName);
                            if (props.tableName === "detectedBreach") {
                                props.setTitleNameDetectedBreach("organization");
                            } else {
                                props.setTitleNameSavedBreach("organization");
                            }
                        }}
                    >
                        {getRenderArrow("organization")}
                        Organization
                        {props.renderSortArrow("organization", props.tableName)}
                    </button>
                </TH>

                <TH className={`${getTableName("breachDate") ? "highlight-exposure-table-heading hide-exposure-col" : "hide-exposure-col"}`}>
                    <button
                        style={{ display: "flex", width: "10vw" }}
                        onClick={() => {
                            props.handleSort("breachDate", props.tableName);
                            if (props.tableName === "detectedBreach") {
                                props.setTitleNameDetectedBreach("breachDate");
                            } else {
                                props.setTitleNameSavedBreach("breachDate");
                            }
                        }}
                        className="header-button"
                    >
                        {getRenderArrow("breachDate")}
                        Breach Date
                        {props.renderSortArrow("breachDate", props.tableName)}
                    </button>
                </TH>

                <TH style={{ width: "45vw" }} className="hide-exposure-col">
                    Affected Data Types
                </TH>

                <TH
                    style={{ width: props.tableName === "savedBreach" ? "22vw" : "25vw" }}
                    className={`${getTableName("breachRiskRating") ? "highlight-exposure-table-heading" : ""}`}
                >
                    <div style={{ display: "flex" }}>
                        <button
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                                props.handleSort("breachRiskRating", props.tableName);
                                if (props.tableName === "detectedBreach") {
                                    props.setTitleNameDetectedBreach("breachRiskRating");
                                } else {
                                    props.setTitleNameSavedBreach("breachRiskRating");
                                }
                            }}
                            className="header-button"
                        >
                            {getRenderArrow("breachRiskRating")}
                            Breach Risk Rating
                        </button>

                        <button
                            style={{ cursor: "pointer", padding: "0px 3px" }}
                            onClick={() => {
                                window.addToDataLayer({ event: "breachIQTooltipRiskRating" });
                                props.setIsRiskDialogOpen(true);
                            }}
                            className="header-button"
                            id={`${props.tableName}-btn` }
                        >
                            <img src={InfoIcon} style={{ width: "1rem" }} alt="Circle with the letter 'i' in the center, signifying information" />
                        </button>

                        {props.renderSortArrow("breachRiskRating", props.tableName, () => {
                            props.handleSort("breachRiskRating", props.tableName);
                            if (props.tableName === "detectedBreach") {
                                props.setTitleNameDetectedBreach("breachRiskRating");
                            } else {
                                props.setTitleNameSavedBreach("breachRiskRating");
                            }
                        })}
                    </div>
                </TH>

                <TH></TH>
            </tr>
        </thead>
    );
}

export default ExposureTableHead;
